import { LESSON_TYPES } from '@classCreation/data/lessonTypes';

function isHybridContest(lessons) {
  let liveLectureExists = lessons.some(
    (lesson) => lesson.lesson_type === LESSON_TYPES.liveLecture
  );
  let contestExists = lessons.some(
    (lesson) => lesson.lesson_type === LESSON_TYPES.contest
  );

  return liveLectureExists && contestExists;
}

export default isHybridContest;
